export default {
  Oil: 'Oil',
  OilId: 1,
  Coolant: 'Coolant',
  CoolantId: 2
};
